import { browser } from '$app/environment';
import { writable } from 'svelte/store';

const localeDefaultValue = 'en';
const localStorageItem = 'crypto_lang';

const localeInitialValue = browser
	? window?.localStorage.getItem(localStorageItem) ?? localeDefaultValue
	: localeDefaultValue;

const activeLocale = writable<{
	locale: string;
}>({
	locale: localeInitialValue,
});

activeLocale.subscribe((value) => {
	if (browser && window.localStorage) {
		window.localStorage.setItem(localStorageItem, value.locale);
	}
});

export default activeLocale;
